import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaPlus, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import TableEmptyState from "../ReusableComponents/TableEmptyState";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";



const Entrevista = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_entrevistas, setLoadingentrevistas] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [entrevistas, setentrevistas] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name, inicio, simulado } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [entrevista_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getentrevistas = async (page, search) => {

    let response = await Request.Get(`faculdade/get_entrevistas/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setentrevistas(response.entrevistas);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingentrevistas(false);


    }
  };

  const DeleteRedacao = async (entrevista_id) => {

    let response = await Request.Delete(`faculdade/delete_entrevista/${entrevista_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getentrevistas(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getentrevistas(1, search_oficial);
  }, []);
  const user = useSelector((state) => state.AppReducer.user);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <>

            <>


                {/* <hr /> */}
                {loading_screen == false && <div className="module-card-container">

                    <div className="module-breadcrumb">

                        <button
              className="breadcrumb-back"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{t("dashboard")}


            </button>

                        <span>/</span>

                        <strong>{t("interviews")}

            </strong>

                    </div>

                    <div className="module-title-row">

                        <div>

                            <h3 style={{ fontWeight: 'bold' }}>{t("interviews")}

              </h3>

                            <p>{`
                                ${t("legacy_gerencie_as_entrevistas_vinculadas_ao_processo")}
                            `}</p>

                        </div>

                        <button
              className="btn-dashboard-modern"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{`
                        ${t("legacy_dashboard")}
                    `}
            </button>


                        

                    </div>

                    <div className="module-toolbar">

                        <Search
              placeholder={t("legacy_pesquisar_pelo_nome_da_entrevista")}
              ValueChange={(value) => {

                clearTimeout(pesquisarTimeout);

                setSearchOficial(value);

                pesquisarTimeout = setTimeout(() => {

                  let page = { ...pagination };

                  page.current_page = 1;

                  setPagination(page);

                  setLoadingentrevistas(true);

                  Getentrevistas(1, value);

                }, 500);

              }} />

                        {entrevistas.length === 0 &&

            <Link
              to={`/entrevistas/register/${processo_id}`}
              className="btn-module-primary">

                                <FaPlus />{`

                                ${t("legacy_adicionar_entrevista")}
                            `}</Link>

            }

                    </div>

                    <div className="table-modern-card">

                        <table
              id="tech-companies-1"
              className="table table-striped">


                            <thead>

                                <tr>

                                    <th>{t("label_name")}</th>

                                    <th>{t("legacy_criterios")}</th>

                                    <th>{t("label_actions")}</th>

                                </tr>

                            </thead>

                            <tbody>

                                {!loading_entrevistas && entrevistas.map((item, id) =>

                <tr key={id}>

                                        <td>

                                            <strong>
                                                {item.name}
                                            </strong>

                                        </td>

                                        <td>

                                            <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px'
                      }}>


                                                {item.criterios.map((criterio, index) =>

                      <span key={index}>

                                                        <strong>
                                                            {criterio.code}
                                                        </strong>

                                                        {" - "}

                                                        {criterio.text}

                                                        {" • Nota "}

                                                        {criterio.min_score}

                                                        {" a "}

                                                        {criterio.max_score}

                                                    </span>

                      )}

                                            </div>

                                        </td>

                                        <td>

                                            <div className="actions-group">

                                                <Link
                        to={`/entrevistas/show/${item.id}`}>

                                                    <button
                          className="action-btn warning"
                          title={t("legacy_visualizar")}>

                                                        <BsFillEyeFill />
                                                    </button>
                                                </Link>

                                                <Link
                        to={`/entrevistas/edit/${item.id}`}>

                                                    <button
                          className="action-btn info"
                          title={t("edit")}>

                                                        <MdModeEdit />
                                                    </button>
                                                </Link>

                                                <button
                        className="action-btn danger"
                        title={t("action_delete")}
                        onClick={() => {

                          setRedacaoId(item.id);

                          setShowWarning(true);

                        }}>

                                                    <MdDelete />
                                                </button>

                                            </div>

                                        </td>

                                    </tr>

                )}

                            </tbody>

                        </table>

                        {loading_entrevistas &&

            <div className="row m-0">

                                <div className="col-12 d-flex justify-content-center align-items-center">

                                    <CircularProgress />

                                </div>

                            </div>

            }

                    </div>

                    {!loading_entrevistas && entrevistas.length === 0 &&
          <TableEmptyState title={t("ui_nenhuma_entrevista_encontrada_3eed3914")} icon="🎤" />
          }

                    <Pagination
            className={
            pagination.last_page === 1 ?
            "hide" :
            ""
            }
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px"
            }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {

              setLoadingentrevistas(true);

              let page = { ...pagination };

              page.current_page = value;

              setPagination(page);

              Getentrevistas(
                value,
                search_oficial
              );

            }} />


                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingentrevistas(true);
            DeleteRedacao(entrevista_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("legacy_sim_desejo_apagar")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_deletar_esta_entrevista_ele_nao_estara_mais_dis_2a6785b8")}


        </SweetAlert>


            </>

        </>);

};

export default Entrevista;
